import React from 'react';

import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { initialSearchValues, SearchFormValues, searchSchema } from '../../schema';
import { type SearchFieldActions, type SearchFieldState } from '../../hooks';
import BasicInfoTab from './BasicInfoTab';
import DetailTab from './DetailTab';

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (filters: MuaHangRecord) => void;
  searchParams?: SearchFormValues;
  searchFieldState: SearchFieldState;
  searchFieldActions: SearchFieldActions;
}

const SearchDialog = ({
  open,
  onClose,
  onSearch,
  searchParams,
  searchFieldState,
  searchFieldActions
}: SearchDialogProps) => {
  const handleSubmit = (data: SearchFormValues) => {
    onSearch({
      ...data,
      ma_kh: searchFieldState.nhaCungCap?.uuid || undefined,
      tk: searchFieldState.taiKhoanCo?.uuid || undefined,
      ma_vt: searchFieldState.vatTu?.uuid || undefined,
      ma_kho: searchFieldState.khoHang?.uuid || undefined,
      ma_lo: searchFieldState.lo?.uuid || undefined,
      ma_vi_tri: searchFieldState.viTri?.uuid || undefined,
      ma_unit: searchFieldState.donVi?.uuid || undefined
    });
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Lọc Hóa đơn mua hàng trong nước'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={searchParams || initialSearchValues}
        onSubmit={handleSubmit}
        className='w-[800px]'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
            <BasicInfoTab formState={{ state: searchFieldState, actions: searchFieldActions }} />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'detail',
                  label: 'Chi tiết',
                  component: <DetailTab searchFieldState={searchFieldState} searchFieldActions={searchFieldActions} />
                }
              ]}
              className='border-b border-b-gray-200'
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 onClose={onClose} mode='search' />}
      />
    </DialogV2>
  );
};

export default SearchDialog;
